var map = {
	"./amex.png": 1024,
	"./diners.png": 1025,
	"./discover.png": 1026,
	"./jcb.png": 1027,
	"./maestro.png": 1256,
	"./mastercard.png": 1028,
	"./stripe.png": 1029,
	"./union.png": 1030,
	"./unknown.png": 709,
	"./visa.png": 1031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1255;